export default {
  error: 'center red-text',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/messages.js